// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Mbe8I","colMin":"styles_colMin__2B201"};